import { Grid } from "antd";
import { FC, useState } from "react";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import { useWatch } from "antd/es/form/Form";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { useCheckoutMutation } from "src/store/slices/Topup/Topup";
import { useTopupDetails } from "../../context/TopupDetailsContext";
import { formulateTopupOrderRequest } from "../../utils";
import RechargeButtonWeb from "./RechargeButton.web";
import RechargeButtonMob from "./RechargeButton.mob";
import { RechargeValues } from "./RechargeConfirmation";

const RechargeButtonComponent = withConditionalComponent(RechargeButtonWeb, RechargeButtonMob);

type Props = RechargeValues & { triggerLabel?: string };

const RechargeButton: FC<Props> = (props) => {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const { item } = useTopupDetails();
  const form = useFormInstance();
  const getAmount = useWatch("getAmount", form);
  const payPoints = useWatch("payPoints", form);
  const [isOpen, setIsOpen] = useState(false);
  const [request, { isLoading, error, data, reset }] = useCheckoutMutation();

  const handleOpen = () => setIsOpen(true);

  const handleCancel = () => {
    reset();
    setIsOpen(false);
  };

  const handleBack = () => reset();

  const handleSubmit = () => {
    const requiredFieldsInputs = (item?.requiredFields ?? []).reduce(
      (acc, field) => {
        acc[field.name] = form.getFieldValue(field.name);
        return acc;
      },
      {} as Record<string, string>,
    );

    const orderRequest = formulateTopupOrderRequest({
      itemCode: item?.code ?? "",
      amount: getAmount,
      points: payPoints,
      requiredFieldsInputs,
    });
    request(orderRequest);
  };

  return (
    <RechargeButtonComponent
      trigger={isLargeScreen}
      props={{ ...props, isOpen, isLoading, error, data, handleOpen, handleSubmit, handleCancel, handleBack }}
    />
  );
};

export default RechargeButton;
